module.exports = __webpack_public_path__ + "static/media/transport-logistics-products.07090dd2.webp";